import React from 'react';
import { platformUrls } from '../data/mockData';
import { protocolPriceNote } from '../data/serviceContent';
import { WellnessImage } from './ui/WellnessImage';

const inputs = [
  { title: 'Blood Work', detail: 'Lab findings' },
  { title: 'Intake', detail: 'Health history' },
  { title: 'Goals', detail: 'Your priorities' },
  { title: 'Wearables', detail: 'When available', optional: true },
  { title: 'DNA', detail: 'When available', optional: true },
];

export default function ProtocolSection() {
  return (
    <section id="protocol" className="hbk-section hbk-protocol" data-testid="protocol-section" aria-labelledby="protocol-heading">
      <div className="max-w-7xl mx-auto px-4">
        <div className="hbk-protocol-intro">
          <div>
            <p className="section-marker" data-testid="protocol-label">CONNECT YOUR DATA</p>
            <h2 id="protocol-heading" className="section-heading hbk-protocol-heading" data-testid="protocol-heading">Your Labs Are One Piece of the Picture. <span>We Connect the Rest.</span></h2>
            <p className="hbk-section-intro" data-testid="protocol-description">Available information, considered together—not in isolation.</p>
          </div>
          <WellnessImage name="protocol" testId="protocol-connected-health-image" className="hbk-protocol-image" sizes="(max-width: 767px) 220px, 280px" />
        </div>
        <ul className="hbk-data-inputs" aria-label="Information that can inform your personalized protocol" data-testid="protocol-inputs">
          {inputs.map(({ title, detail, optional }, i) => (
            <li key={title} className={optional ? 'hbk-data-input is-optional' : 'hbk-data-input'} data-testid={`protocol-input-${i + 1}`}>
              <strong className="hbk-data-input-title" data-testid={`protocol-input-title-${i + 1}`}>{title}</strong>
              <span className="hbk-data-input-detail" data-testid={`protocol-input-description-${i + 1}`}>{detail}</span>
              {i < inputs.length - 1 && <span className="hbk-data-plus" aria-hidden="true">+</span>}
            </li>
          ))}
        </ul>
        <div className="hbk-data-arrow" aria-hidden="true">↓</div>
        <div className="hbk-protocol-result" data-testid="protocol-outcome">
          <div>
            <h3 className="hbk-protocol-result-heading" data-testid="protocol-outcome-heading">Personalized Protocol</h3>
            <p className="text-base mt-2" data-testid="protocol-outcome-description">Wellness guidance built around your data and priorities.</p>
          </div>
          <a href={platformUrls.intake} target="_blank" rel="noopener noreferrer" className="btn-cta hbk-short-cta" data-testid="protocol-analysis-cta">START MY PROTOCOL</a>
        </div>
        <p className="hbk-protocol-note" data-testid="protocol-pricing-note">Wearables and DNA are optional inputs. {protocolPriceNote}</p>
        <details className="hbk-technology-note" data-testid="protocol-technology">
          <summary className="hbk-detail-summary" data-testid="protocol-technology-toggle">Behind the analysis</summary>
          <p className="text-sm pb-4 max-w-3xl" data-testid="protocol-technology-description">The Integrated Matrix Engine and Clinical Performance Index (CPI) help organize and analyze the combined information. They support the team’s review; they do not replace clinical judgment.</p>
        </details>
      </div>
    </section>
  );
}